import React from 'react';

import PropTypes from 'prop-types';
import { Accordion, Icon } from 'semantic-ui-react';

import clsx from 'clsx';
import _isEmpty from 'lodash/isEmpty';

import { itemPropType } from '../../AccordionNavigationMenu.types';

const propTypes = {
  item: itemPropType.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  onSelectFolder: PropTypes.func.isRequired,
  openItemIds: PropTypes.arrayOf(PropTypes.string),
  highlightedItemIds: PropTypes.arrayOf(PropTypes.string),
  folderIcon: PropTypes.string,
  fileIcon: PropTypes.string,
};

const defaultProps = {
  openItemIds: [],
  highlightedItemIds: [],
  folderIcon: 'caret right',
  fileIcon: 'file outline',
};

function AccordionNavigationMenuChild({
  item,
  openItemIds,
  onSelectFolder,
  onSelectItem,
  highlightedItemIds,
  folderIcon,
  fileIcon,
}) {
  const { items, id, name } = item;

  function isActive(currentId, childItems) {
    if (openItemIds.includes(currentId)) return true;
    if (!childItems) return false;
    return childItems.some((childItem) => isActive(childItem.id, childItem.items));
  }

  function onSelectFolderInternal() {
    return onSelectFolder(id);
  }

  const isActiveFolder = isActive(id, items);
  const isFolder = !_isEmpty(items);
  const highlighted = highlightedItemIds.includes(id);

  if (isFolder) {
    return (
      <>
        <Accordion.Title
          onClick={onSelectFolderInternal}
          active={isActiveFolder}
          className={clsx({ highlighted })}
        >
          <Icon name={folderIcon} className="dropdown icon" />
          <span>{name}</span>
        </Accordion.Title>
        <Accordion.Content active={isActiveFolder}>
          <Accordion.Accordion>
            {items.map((childItem) => (
              <AccordionNavigationMenuChild
                key={childItem.id}
                item={childItem}
                openItemIds={openItemIds}
                onSelectItem={onSelectItem}
                onSelectFolder={onSelectFolder}
                highlightedItemIds={highlightedItemIds}
                folderIcon={folderIcon}
                fileIcon={fileIcon}
              />
            ))}
          </Accordion.Accordion>
        </Accordion.Content>
      </>
    );
  }

  return (
    <Accordion.Title onClick={() => onSelectItem(item)} className={clsx({ highlighted })}>
      <Icon name={fileIcon} />
      <span>{name}</span>
    </Accordion.Title>
  );
}

AccordionNavigationMenuChild.propTypes = propTypes;
AccordionNavigationMenuChild.defaultProps = defaultProps;

export default AccordionNavigationMenuChild;
